export const boookingColumns = [
  { field: "_id", headerName: "ID", width: 250 },
  // { field: "user_id", headerName: "User ID", width: 250 },
  {
    field: "user_name",
    headerName: "Username",
    width: 100,
  },
  {
    field: "stripe_receipt_url",
    headerName: "Receipt",
    width: 100,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <a
            style={{
              padding: "2px 10px",
              borderRadius: 5,
              color: "darkblue",
              border: "1px dotted rgba(0, 0, 139, 0.596)",
              cursor: "pointer",
              textDecoration: "none",
            }}
            target="_blank"
            href={params.row?.stripe_receipt_url}
          >
            View
          </a>
        </div>
      );
    },
  },

  {
    field: "amount",
    headerName: "Amount",
    width: 100,
    renderCell: (params) => {
      return <div className="cellWithImg">{params.row?.amount}$</div>;
    },
  },
  {
    field: "unavailableDates:",
    headerName: "Booked Dates",
    width: 150,
    minWidth: 150,
    renderCell: (params) => {
      const data = params?.row.unavailableDates.map((data, i) => {
        return " " + new Date(data).toLocaleDateString() + " , ";
      });
      return (
        <div className="cellWithImg">
          <select style={{ border: "none", width: 90, cursor: "pointer",
             padding: "2px 5px",
              borderRadius: 5,
              color: "darkblue",
              border: "1px dotted rgba(0, 0, 139, 0.596)",
              cursor: "pointer",
        
           }}>
            <option
          //   style={{ 
          //     border: "none",
          //      cursor: "pointer",
          //    padding: "2px 5px",
          //     borderRadius: 5,
          //     color: "darkblue !important",
          //     height: "100px",
            
        
          //  }}
            
            >{data}</option>
          </select>
        </div>
      );
    },
  },
];

export const userColumns = [
  { field: "_id", headerName: "ID", width: 250 },
  {
    field: "user",
    headerName: "User",
    width: 230,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          <img
            className="cellImg"
            src={params.row.img || "https://i.ibb.co/MBtjqXQ/no-avatar.gif"}
            alt="avatar"
          />
          {params.row.username}
        </div>
      );
    },
  },
  {
    field: "email",
    headerName: "Email",
    width: 230,
  },

  {
    field: "country",
    headerName: "Country",
    width: 100,
  },
  {
    field: "city",
    headerName: "City",
    width: 100,
  },
  {
    field: "phone",
    headerName: "Phone",
    width: 100,
  },
];

export const hotelColumns = [
  { field: "_id", headerName: "ID", width: 250 },
  {
    field: "name",
    headerName: "Name",
    width: 150,
  },
  {
    field: "type",
    headerName: "Type",
    width: 100,
  },
  {
    field: "title",
    headerName: "Title",
    width: 230,
  },
  {
    field: "city",
    headerName: "City",
    width: 100,
  },
];

export const roomColumns = [
  { field: "_id", headerName: "ID", width: 250 },
  {
    field: "title",
    headerName: "Title",
    width: 230,
  },
  {
    field: "desc",
    headerName: "Description",
    width: 200,
  },
  {
    field: "price",
    headerName: "Price",
    width: 100,
  },
  {
    field: "maxPeople",
    headerName: "Max People",
    width: 100,
  },
];
